var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home animated fadeIn",style:(_vm.home_height)},[_c('img',{staticClass:"icon-singing",attrs:{"src":require("../assets/iconSinging.png")}}),_c('Button',{attrs:{"text":"下载小睡眠APP"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }